module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_yakisoba.8f80c89c.png";